import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "mb-3 space-y-1.5" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'BrandEmailPreview',
    props: {
        colors: {},
        fontFamily: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "mt-4 overflow-hidden rounded-lg border border-ewhite-200 p-3",
                style: _normalizeStyle({ backgroundColor: __props.colors.background, fontFamily: __props.fontFamily })
            }, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mb-3 h-5 w-5 rounded bg-ewhite-200" }, null, -1)),
                _createElementVNode("div", {
                    class: "rounded-lg border-2 p-3",
                    style: _normalizeStyle({ borderColor: __props.colors.accent })
                }, [
                    _createElementVNode("div", {
                        class: "mb-3 rounded border p-1",
                        style: _normalizeStyle({ borderColor: __props.colors.accent })
                    }, [...(_cache[0] || (_cache[0] = [
                            _createElementVNode("div", { class: "h-6 w-full rounded bg-ewhite-200" }, null, -1)
                        ]))], 4),
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", {
                            class: "h-3 w-2/3 rounded",
                            style: _normalizeStyle({ backgroundColor: __props.colors.text })
                        }, null, 4),
                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "h-2 w-full rounded bg-ewhite-200" }, null, -1)),
                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "h-2 w-4/5 rounded bg-ewhite-200" }, null, -1))
                    ]),
                    _createElementVNode("div", {
                        class: "mb-3 rounded border p-2",
                        style: _normalizeStyle({ borderColor: __props.colors.accent })
                    }, [...(_cache[3] || (_cache[3] = [
                            _createStaticVNode("<div class=\"space-y-1 border-b border-ewhite-100 pb-2\"><div class=\"h-1.5 w-1/4 rounded bg-ewhite-300\"></div><div class=\"h-2 w-1/2 rounded bg-ewhite-200\"></div></div><div class=\"space-y-1 pt-2\"><div class=\"h-1.5 w-1/4 rounded bg-ewhite-300\"></div><div class=\"h-2 w-1/2 rounded bg-ewhite-200\"></div></div>", 2)
                        ]))], 4),
                    _createElementVNode("div", {
                        class: "h-7 w-1/3 rounded",
                        style: _normalizeStyle({ backgroundColor: __props.colors.primary })
                    }, null, 4)
                ], 4),
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mt-3 border-t border-ewhite-200 pt-2" }, [
                    _createElementVNode("div", { class: "mx-auto h-2 w-1/4 rounded bg-ewhite-200" })
                ], -1))
            ], 4));
        };
    }
});
